import {useState} from 'react';

import {Button, Header, Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';

import CreatePlanModal from './CreatePlanModal';
import SubscriptionPlanTable from './SubscriptionPlanTable';
import type {AfriexSubscriptionPlan} from './types';
import UpdatePlanModal from './updatePlanModal';
import useSubscriptionPlans from './useSubscriptionPlans';

const SubscriptionPlansPage = () => {
  const {
    isLoading,
    isSearch,
    isPageReset,
    fetchAllPlans,
    pageInfo,
    subscriptionPlanList,
    handleUpdate,
    handleCreate,
    errors,
    deletePlan,
    subPlanFeatures,
    subPlanIntervals,
  } = useSubscriptionPlans();

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedPlan, setSelectedPlan] =
    useState<AfriexSubscriptionPlan | null>(null);

  const loadedContent =
    subscriptionPlanList && subscriptionPlanList.data.length ? (
      <SubscriptionPlanTable
        items={subscriptionPlanList.data}
        isLoading={isLoading}
        setSelectedPlan={setSelectedPlan}
        setShowUpdateModal={setShowUpdateModal}
      />
    ) : (
      <div className="flex items-center gap-1 justify-center mt-5">
        <p className="text-gray-800 dark:text-white">
          No Subscription Plans found.
        </p>
      </div>
    );

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title={`Subscription Plans`} />

      <div className="flex flex-row justify-end">
        <Button variant="solid" onClick={() => setShowCreateModal(true)}>
          Create Plan
        </Button>
      </div>
      <section className="pt-5 md:pt-5">
        {isLoading ? <TableSkeleton /> : loadedContent}
      </section>

      {showCreateModal ? (
        <CreatePlanModal
          isOpen={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          label={`Create Subscription Plan`}
          onSubmit={handleCreate}
          subPlanFeatures={subPlanFeatures}
          subPlanIntervals={subPlanIntervals}
          errors={errors}
          loading={isLoading}
        />
      ) : null}

      {showUpdateModal ? (
        <UpdatePlanModal
          isOpen={showUpdateModal}
          onClose={() => setShowUpdateModal(false)}
          label={`Update Subscription Plan`}
          onSubmit={handleUpdate}
          onDelete={deletePlan}
          errors={errors}
          loading={isLoading}
          selectedPlan={selectedPlan}
        />
      ) : null}
      {subscriptionPlanList && subscriptionPlanList.data.length ? (
        <Pagination
          onPageChange={fetchAllPlans as PaginationProps['onPageChange']}
          total={pageInfo.total}
          isSearch={isSearch}
          isPageReset={isPageReset}
        />
      ) : null}
    </main>
  );
};

export default SubscriptionPlansPage;
